import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { OdbcDataset } from 'app/model/dataset/odbc.dataset';
import { Metamodel } from 'app/model/base/model';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OdbcDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class OdbcDatasetAdapter extends TabularTypeDatasetAdapter<OdbcDataset, Model.DatasetResource> {
}
